import { AppInfo } from '@common/app.utils';

// Util to Redirect on Client Side to Mobile View if desired
// as extra script to load before full script for per reasons

/**
 * Detects if the current browser is on a mobile device.
 * (analagous with PDFTron ...)
 */
function isMobileDevice() {
    if (_isMobileDevice === undefined) {
        if (isIE())
            return _isMobileDevice = false;

        const userAgent = navigator.userAgent;
        if (userAgent.match(/Edge/i) && scrollbarWidth() === 0)
            return _isMobileDevice = true;

        const mCount = mobileUserAgents.length;
        for (var i = 0; i < mCount; i++) {
            if (userAgent.match(mobileUserAgents[i])) {
                return _isMobileDevice = true;
            }
        }
        return _isMobileDevice = false;
    }
    return _isMobileDevice;
}
var _isMobileDevice: boolean = undefined;

const mobileUserAgents = [
    // /Edge/i see above
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPod/i,
    /iPad/i,
    /Touch/i,
    /IEMobile/i,
    /Silk/i];

// In windows 10 tablets, the tablet mode and desktop mode use the same user agent.  HOWEVER
// the scrollbar width in tablet mode is 0. This means that we can find the scrollbar width
// and use it to determine if they are in tablet mode (mobile viewer) or desktop mode
function scrollbarWidth() {
    if (typeof _scrollbarWidth !== "number") {
        var scrollDiv = document.createElement('div');
        scrollDiv.style.cssText = 'width:100px;height:100px;overflow:scroll !important;position:absolute;top:-9999px';
        document.body.appendChild(scrollDiv);
        _scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
    }
    return _scrollbarWidth;
}
var _scrollbarWidth: number;

function isIE() {
    var ua = navigator.userAgent.toLowerCase();
    var match = /(msie) ([\w.]+)/.exec(ua) || /(trident)(?:.*? rv:([\w.]+)|)/.exec(ua);
    return match ? parseInt(match[2], 10) : match;
}

/** Determin RWF Specific mobile Url for given default url if applicapel, or undefined if not */
export function TransformToMobile(relativeUrl: string, _isMobileDevice?: () => boolean, windowlocationhref?: string) {

    const pMobile = getParameterByName("mobile");

    if (pMobile && pMobile.toLowerCase() == "false") {
        return;
    }

    if (pMobile && pMobile.toLowerCase() == "true") {
        // Force mobile redirect
    }
    else if (!(_isMobileDevice || isMobileDevice)()) {
        // No Mobile Redirect
        return;
    }

    if (!relativeUrl || typeof relativeUrl !== "string") {
        return;
    }
    const reCheckEditForm = reIsEditForm.exec(relativeUrl);

    if (reCheckEditForm && reCheckEditForm.length == 4) {
        const pre = reCheckEditForm[1].replace(/(\/index.html)?\/?$/, '');
        let post = getParameterByName("company") || "";
        if (post) {
            post = "&company=" + post;
        }
        return `${pre}/index.mobile.html#rwf-route-view?wfInstanceId=${unescape(reCheckEditForm[2])}${post}`;
    }

    const reCheckUserDesk = reIsUserDesk.exec(relativeUrl);
    if (reCheckUserDesk) {
        const pre = reCheckUserDesk[1].replace(/(\/index.html)?\/?$/, '');
        let post = getParameterByName("company") || "";
        if (post) {
            post = "?company=" + post;
        }

        return `${pre}/index.mobile.html${post}`;
    }

    function getParameterByName(name) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(windowlocationhref || window.location.href);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}
const reIsEditForm = /^(.*)#\/kwfEditForm\/([^\?\\]+)\?(.*)$/;
const reIsUserDesk = /^(.*)#\/userdesk\?(.*)$/;

if (!AppInfo.IsTest) {
    var mobile = TransformToMobile(window.document.location.toString());
    if (mobile) {
        window.location.replace(mobile);
    }
}
